/**
 * Chat Widget Loader
 * This is the initial script that gets loaded via the script tag.
 * It creates the container and initializes the chat widget Web Component.
 */


(function () {
  'use strict';
  window.__SYSDEFAULT__ = '__SYSDEFAULT__';

  const sysdefault = window.__SYSDEFAULT__; // chatbot or wxo

  // Prevent multiple initializations
  if (window.MyChatWidgetLoaded) {
    return;
  }
  window.MyChatWidgetLoaded = true;

  /**
   * Initialize the chat widget
   */
  function initWidget() {
    try {
      // Get configuration from window
      const config = window.MyChatConfig || {};

      // Validate required configuration
      if (!config.apiUrl) {
        return;
      }

      // Create container element for the widget
      const container = document.createElement('div');
      container.id = 'my-chat-widget-container';
      container.setAttribute('data-chat-widget', 'true');

      // Apply positioning styles to prevent layout shift
      container.style.cssText = `
        position: fixed;
        z-index: 999999;
        pointer-events: none;
      `;

      // Create the chat widget custom element
      const chatWidget = document.createElement('chat-widget');

      // Pass configuration via attributes
      if (config.apiUrl) chatWidget.setAttribute('api-url', config.apiUrl);
      if (config.agentId) chatWidget.setAttribute('agent-id', config.agentId);
      if (config.theme) chatWidget.setAttribute('theme', config.theme);
      if (config.position) chatWidget.setAttribute('position', config.position);
      if (config.primaryColor) chatWidget.setAttribute('primary-color', config.primaryColor);
      if (config.title) chatWidget.setAttribute('title', config.title);
      if (config.greeting) chatWidget.setAttribute('greeting', config.greeting);
      if (config.placeholder) chatWidget.setAttribute('placeholder', config.placeholder);

      // Enable pointer events on the widget itself
      chatWidget.style.pointerEvents = 'auto';

      // Append widget to container
      container.appendChild(chatWidget);

      // Add container to DOM
      if (document.body) {
        document.body.appendChild(container);
      } else {
        // Wait for body to be available
        document.addEventListener('DOMContentLoaded', function () {
          document.body.appendChild(container);
        });
      }

      // Expose widget instance globally for debugging
      window.MyChatWidget = chatWidget;

      // Log successful initialization (only in development)
      if (config.debug) {
        // Debug logging removed for production
      }
    } catch (error) {
      // Error handling without console output
    }
  }

  /**
   * Load the widget bundle dynamically
   */
  function loadWidgetBundle() {
    const script = document.createElement('script');
    const currentScript = document.currentScript || document.querySelector('script[src*="loader.js"]');

    // Determine the base URL from the current script
    let baseUrl = '';
    if (currentScript && currentScript.src) {
      baseUrl = currentScript.src.substring(0, currentScript.src.lastIndexOf('/') + 1);
    }

    // Set script source — append build timestamp to bust browser cache on each deploy
    script.src = baseUrl + 'widget.js?v=' + (window.__WIDGET_VERSION__ || Date.now());
    script.type = 'module';
    script.async = true;

    // Handle script load success
    script.onload = function () {
      // Wait a bit for the custom element to be defined
      if (customElements.get('chat-widget')) {
        initWidget();
      } else {
        // Wait for custom element to be defined
        customElements.whenDefined('chat-widget').then(() => {
          initWidget();
        }).catch((error) => {
          // Error handling without console output
        });
      }
    };

    // Handle script load error
    script.onerror = function (error) {
      // Error handling without console output

      // Try to provide helpful error message
      const config = window.MyChatConfig || {};
      if (config.debug) {
        // Debug logging removed for production
      }
    };

    // Append script to head
    document.head.appendChild(script);
  }

  /**
   * Start loading process
   */
  function start() {

    if (sysdefault == "chatbot") {
      window.MyChatConfig = {
        apiUrl: 'https://chatbot-fiscal-api.igs-os-prod-aut-01-4592b969e5d47739c81141a146b35c69-0000.br-sao.containers.appdomain.cloud',
        agentId: 'agent-fiscal',
        theme: 'ibm',
        position: 'bottom-right',
        primaryColor: '#0f62fe',
        greeting: 'Olá! Bem vindo ao agente de recebimento fiscal Iguá!',
        title: 'Recebimento Fiscal',
        placeholder: ''
      };
    } else if (sysdefault == "wxo") {
      window.wxOConfiguration = {
        orchestrationID: "75b779a6219749f38f2ab5f5f3ada1ba_47f4e30c-191e-4262-affb-31b283c17a76",
        hostURL: "https://us-south.watson-orchestrate.cloud.ibm.com",
        rootElementID: "root",
        deploymentPlatform: "ibmcloud",
        crn: "crn:v1:bluemix:public:watsonx-orchestrate:us-south:a/75b779a6219749f38f2ab5f5f3ada1ba:47f4e30c-191e-4262-affb-31b283c17a76::",
        chatOptions: {
          agentId: "a5b52977-5744-47c1-aa27-b7ea7eebc596",
          agentEnvironmentId: "c0391d72-5cc9-4a6a-8787-12a83be184f7",
        },
        header: {
          showMaximize: true,
          showAiDisclaimer: false,
          hide_reasoning: true
        },
        style: {
          headerColor: '#0043CE',
          primaryColor: '#0043CE',
        }
      };

      setTimeout(function () {
        const script = document.createElement('script');
        script.src = `${window.wxOConfiguration.hostURL}/wxochat/wxoLoader.js?embed=true`;
        script.addEventListener('load', function () {
          wxoLoader.init();
        });
        document.head.appendChild(script);
      }, 0);
    };


    // Check if we're in a browser environment
    if (typeof window === 'undefined' || typeof document === 'undefined') {
      return;
    }

    // Load widget when DOM is ready
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', loadWidgetBundle);
    } else {
      // DOM is already ready
      loadWidgetBundle();
    }


  }

  // Start the loading process
  start();
})();
